import React, { useEffect, createRef, useState } from 'react';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { NEW, VIEW, UPDATE } from '../../assets/Constants/actionsTypes';
import { useTranslation } from 'react-i18next';

import { /*BENEFFICIARY_UNIT,*/ CASH_OR_KIND, EXIST_BENEFIT, PERMANENT_OR_TEMPORAL, FINANCING_SOURCE } from '../../assets/Constants/enums';

import validator from 'validator';

const BenefitModal = (props) => {

  // we call the hook to make translations
  const { t } = useTranslation('common');

  // we create a reference for the modal
  const window = createRef();

  const [spFunctionId, setspFunctionId] = useState('');
  const [spComponentId, setspComponentId] = useState('');
  const [spGuaranteeId, setspGuaranteeId] = useState('');
  const [name, setname] = useState('');
  const [creationYear, setcreationYear] = useState(0);
  // const [beneficiaryUnit, setbeneficiaryUnit] = useState(BENEFFICIARY_UNIT[0].value);
  const [cashOrKind, setcashOrKind] = useState(CASH_OR_KIND[0].value);
  const [isExistingBenefit, setisExistingBenefit] = useState(EXIST_BENEFIT[0].value);
  const [permanentOrTemporal, setpermanentOrTemporal] = useState(PERMANENT_OR_TEMPORAL[0].value);
  const [schemeName, setschemeName] = useState('');
  const [financingSource, setfinancingSource] = useState(FINANCING_SOURCE[0].value);
  const [adminInstitution, setadminInstitution] = useState('');
  const [responsibleBody, setresponsibleBody] = useState('');
  const [description, setdescription] = useState('');
  const [legalFramework, setlegalFramework] = useState('');


  // this variable allow us know if the save button will be shown or not
  const [showSave, setShowSave] = useState(false);
  // if is in UPDATE mode
  const [isUpdate, setIsUpdate] = useState(false);

  // here you define the configuration that the modal will have. this depends on the type with which it was opened.
  useEffect(() => {
    setspFunctionId(Array.isArray(props.spFunctionList) && props.spFunctionList.length ? props.spFunctionList[0].spFunctionId : '');
    setspComponentId(Array.isArray(props.spComponentList) && props.spComponentList.length ? props.spComponentList[0].spComponentId : '');
    setspGuaranteeId(Array.isArray(props.spGuaranteeList) && props.spGuaranteeList.length ? props.spGuaranteeList[0].spGuaranteeId : '');
    if (props.type === NEW) {
      setShowSave(true);
      setname('');
      setcreationYear('');
      // setbeneficiaryUnit(BENEFFICIARY_UNIT[0].value);
      setcashOrKind(CASH_OR_KIND[0].value);
      setisExistingBenefit(EXIST_BENEFIT[0].value);
      setpermanentOrTemporal(PERMANENT_OR_TEMPORAL[0].value);
      setfinancingSource(FINANCING_SOURCE[0].value);
      setschemeName('');
      setadminInstitution('');
      setresponsibleBody('');
      setdescription('');
      setlegalFramework('');



    } else {
      if (props.data) {
        setspFunctionId(props.data.spFunctionId);
        setspComponentId(props.data.spComponentId);
        setspGuaranteeId(props.data.spGuaranteeId);
        setname(props.data.name);
        setcreationYear(props.data.creationYear);
        // setbeneficiaryUnit(props.data.beneficiaryUnit);
        setcashOrKind(props.data.cashOrKind);
        setisExistingBenefit(props.data.isExistingBenefit);
        setpermanentOrTemporal(props.data.permanentOrTemporal);
        setfinancingSource(props.data.financingSource);
        setschemeName(props.data.schemeName);
        setadminInstitution(props.data.adminInstitution);
        setresponsibleBody(props.data.responsibleBody);
        setdescription(props.data.description);
        setlegalFramework(props.data.legalFramework);
        if (props.type === VIEW) {
          setShowSave(false);
        } else {
          if (props.type === UPDATE) {
            setShowSave(true);
            setIsUpdate(true);
          }
        }
      } else {
        props.toggleWindow();
      }
    }

  }, [props]);

  // with this we make sure to always hide the maximize and minimize buttons.
  useEffect(() => {
    if (window) {
      hideButtons();
    }
  })

  const hideButtons = () => {
    let maximizeButton = window.current.windowElement.querySelector(
      ".k-i-window-maximize"
    ).parentElement;
    maximizeButton.style.visibility = "hidden";

    let minimizeButton = window.current.windowElement.querySelector(
      ".k-i-window-minimize"
    ).parentElement;
    minimizeButton.style.visibility = "hidden";
  }

  return (
    <div className="">
      <Window
        className="ilo-k-window benefit-modal"
        // initialHeight={'78vh'}
        modal={true}
        title={t('benefit.modalTitle')}
        resizable={false}
        draggable={false}
        doubleClickStageChange={false}
        onClose={() => {
          props.toggleWindow();
        }}
        ref={window}
      >
        <div className="container-fluid m-1">
          <div className="form-group row">

            <div className="col-sm-6">
              <label className={showSave ? 'ilo_lbl_general required' : 'ilo_lbl_general'}>{t('benefit.name_label')}</label>
              <input
                type="text"
                disabled={!showSave}
                className="form-control ilo-input ilo-modal-input"
                placeholder={t('benefit.name_ph')}
                value={name}
                onChange={(e) => setname(e.target.value)}
              />
            </div>

            <div className="col-sm-6">
              <label className={showSave ? 'ilo_lbl_general required' : 'ilo_lbl_general'} >{t('benefit.creationYear_label')}</label>
              <input
                type="text"
                disabled={!showSave}
                className="form-control ilo-input ilo-modal-input"
                placeholder={t('benefit.creationYear_ph')}
                value={creationYear}
                onChange={(e) => setcreationYear((validator.isNumeric(e.target.value) && parseInt(e.target.value) > 0) || validator.isEmpty(e.target.value) ? e.target.value : creationYear)}
              />
            </div>

          </div>

          <div className="form-group row">

            <div className="col-sm-6">
              <label className={showSave && !isUpdate ? 'ilo_lbl_general required' : 'ilo_lbl_general'}>{t('benefit.guarantee_label')}</label>
              <select
                value={spGuaranteeId}
                onChange={(e) => { setspGuaranteeId(e.target.value) }}
                disabled={!showSave || isUpdate}
                className="form-control ilo-input ilo-modal-input"
              >
                {
                  Array.isArray(props.spGuaranteeList) && props.spGuaranteeList.length ?
                    props.spGuaranteeList.map((guarantee) => {
                      return (
                        <option key={guarantee.spGuaranteeId} value={guarantee.spGuaranteeId}>
                          {t(`benefit.guarantee.${guarantee.name}`)}
                        </option>
                      );
                    }) :
                    <option value='' disabled>
                      {t('benefit.no_spGuarantee')}
                    </option>
                }
              </select>
            </div>

            <div className="col-sm-6">
              <label className={showSave && !isUpdate ? 'ilo_lbl_general required' : 'ilo_lbl_general'}>{t('benefit.function_label')}</label>
              <select
                value={spFunctionId}
                onChange={(e) => { setspFunctionId(e.target.value) }}
                disabled={!showSave || isUpdate}
                className="form-control ilo-input ilo-modal-input"
              >
                {
                  Array.isArray(props.spFunctionList) && props.spFunctionList.length ?
                    props.spFunctionList.map((spfunction) => {
                      return (
                        <option key={spfunction.spFunctionId} value={spfunction.spFunctionId}>
                          {spfunction.name}
                        </option>
                      );
                    }) :
                    <option value='' disabled>
                      {t('benefit.no_spFunction')}
                    </option>
                }
              </select>
            </div>

          </div>

          <div className="form-group row">

            <div className="col-sm-6">
              <label className={showSave && !isUpdate ? 'ilo_lbl_general required' : 'ilo_lbl_general'}>{t('benefit.component_label')}</label>
              <select
                value={spComponentId}
                onChange={(e) => { setspComponentId(e.target.value) }}
                disabled={!showSave || isUpdate}
                className="form-control ilo-input ilo-modal-input"
              >
                {Array.isArray(props.spComponentList) && props.spComponentList.length ?
                  props.spComponentList.map((spcomponent) => {
                    return (
                      <option key={spcomponent.spComponentId} value={spcomponent.spComponentId}>
                        {spcomponent.name}
                      </option>
                    );
                  }) :
                  <option value='' disabled>
                    {t('benefit.no_spComponent')}
                  </option>
                }
              </select>
            </div>

            <div className="col-sm-6">
              <label className="ilo_lbl_general">{t('benefit.cashOrKind_label')}</label>
              {
                CASH_OR_KIND.map((option, i) => {
                  return (
                    <div className="form-check" key={i}>
                      <input
                        className="form-check-input radio_input"
                        type="radio"
                        onChange={(e) => { setcashOrKind(e.target.value) }}
                        value={option.value}
                        checked={cashOrKind === option.value}
                        disabled={!showSave}
                      />
                      <label className="form-check-label radio_label">{t(`benefit.${option.label}`)}</label>
                    </div>
                  )
                })
              }
            </div>
            
          </div>

          {/* <div className="form-group row">
            <div className="col-sm-6">
              <label className={showSave && !isUpdate ? 'required' : ''}>{t('benefit.beneficiary_label')}</label>
              {
                BENEFFICIARY_UNIT.map((b, i) => {
                  return (
                    <div className="form-check" key={i}>
                      <input
                        className="form-check-input radio_input"
                        type="radio"
                        onChange={(e) => { setbeneficiaryUnit(e.target.value) }}
                        value={b.value}
                        checked={beneficiaryUnit === b.value}
                        disabled={!showSave || isUpdate}
                      />
                      <label className="form-check-label radio_label">{t(`benefit.${b.label}`)}</label>
                    </div>
                  )
                })
              }
            </div>
          </div> */}

          <div className="form-group row">

            <div className="col-sm-6">
              <label className="ilo_lbl_general">{t('benefit.existing_benefit_label')}</label>
              <select
                value={isExistingBenefit}
                onChange={(e) => { setisExistingBenefit(e.target.value) }}
                disabled={!showSave}
                className="form-control ilo-input ilo-modal-input"
              >
                {EXIST_BENEFIT.map((option, i) => {
                  return (
                    <option key={i} value={option.value}>
                      {t(`benefit.${option.label}`)}
                    </option>
                  )
                })}
              </select>

            </div>

            <div className="col-sm-6">
              <label className="ilo_lbl_general">{t('benefit.permanent_or_temporary_label')}</label>
              <select
                value={permanentOrTemporal}
                onChange={(e) => { setpermanentOrTemporal(e.target.value) }}
                disabled={!showSave}
                className="form-control ilo-input ilo-modal-input"
              >
                {PERMANENT_OR_TEMPORAL.map((option, i) => {
                  return (
                    <option value={option.value} key={i}>
                      {t(`benefit.${option.label}`)}
                    </option>
                  )
                })}
              </select>
            </div>

          </div>

          <div className="form-group row">

            <div className="col-sm-6">
              <label className="ilo_lbl_general">{t('benefit.scheme_label')}</label>
              <input
                type="text"
                disabled={!showSave}
                className="form-control ilo-input ilo-modal-input"
                placeholder={t('benefit.scheme_ph')}
                value={schemeName}
                onChange={(e) => setschemeName(e.target.value)}
              />

            </div>

            <div className="col-sm-6">
              <label className="ilo_lbl_general">{t('benefit.financing_source_label')}</label>
              <select
                value={financingSource}
                onChange={(e) => { setfinancingSource(e.target.value) }}
                disabled={!showSave}
                className="form-control ilo-input ilo-modal-input"
              >
                {FINANCING_SOURCE.map((option, i) => {
                  return (
                    <option value={option.value} key={i}>
                      {t(`benefit.financing_source.${option.label}`)}
                    </option>
                  )
                })}
              </select>

            </div>

          </div>

          <div className="form-group row">

            <div className="col-sm-6">
              <label className="ilo_lbl_general">{t('benefit.admin_institution_label')}</label>
              <input
                type="text"
                disabled={!showSave}
                className="form-control ilo-input ilo-modal-input"
                placeholder={t('benefit.admin_institution_ph')}
                value={adminInstitution}
                onChange={(e) => setadminInstitution(e.target.value)}
              />
            </div>

            <div className="col-sm-6">
              <label className="ilo_lbl_general">{t('benefit.responsible_body_label')}</label>
              <input
                type="text"
                disabled={!showSave}
                className="form-control ilo-input ilo-modal-input"
                placeholder={t('benefit.responsible_body_ph')}
                value={responsibleBody}
                onChange={(e) => setresponsibleBody(e.target.value)}
              />
            </div>

          </div>

          <div className="form-group row">

            <div className="col-sm-12">
              <label className="ilo_lbl_general">{t('benefit.description_label')}</label>
              <textarea
                disabled={!showSave}
                className="form-control ilo-input ilo-modal-input-text-area"
                rows="1"
                value={description}
                onChange={(e) => setdescription(e.target.value)}
              ></textarea>
            </div>

          </div>
          <div className="form-group row">

            <div className="col-sm-12">
              <label className="ilo_lbl_general">{t('benefit.legal_framework_label')}</label>
              <textarea
                disabled={!showSave}
                className="form-control ilo-input ilo-modal-input-text-area"
                rows="1"
                value={legalFramework}
                onChange={(e) => setlegalFramework(e.target.value)}
              ></textarea>
            </div>

          </div>



          <WindowActionsBar layout="end">
            {showSave &&
              <button
                onClick={() => {
                  const data = {
                    benefitId: isUpdate ? props.data.benefitId : 0,
                    spFunctionId: parseInt(spFunctionId, 10),
                    spComponentId: parseInt(spComponentId, 10),
                    spGuaranteeId: parseInt(spGuaranteeId, 10),
                    name,
                    creationYear: parseInt(creationYear, 10),
                    // beneficiaryUnit,
                    cashOrKind,
                    isExistingBenefit: String(isExistingBenefit) === "true" ? true : false,
                    permanentOrTemporal,
                    schemeName,
                    financingSource,
                    adminInstitution,
                    responsibleBody,
                    description,
                    legalFramework,
                  }
                  props.onSave(data);
                }}
                className="btn btn-primary ilo-btn"
              >{t('modals.save_btn')}</button>
            }

            <button onClick={props.toggleWindow} className="btn btn-primary ilo-btn">{showSave ? t('modals.cancel_btn') : t('modals.close_btn')}</button>
          </WindowActionsBar>
        </div>
      </Window>
    </div>
  )
}


export default BenefitModal
